/* ─── Privacy Notice page — wrapper and rendered-markdown styles ─────────── */

.pageWrapper {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  background-color: var(--color-bg-primary);
}

.main {
  flex: 1;
}

/* ─── Rendered GFM content ───────────────────────────────────────────────── */

.privacyContent {
  color: var(--color-text-secondary);
  line-height: 1.7;
  font-size: 0.95rem;
}

/* Paragraphs */
.privacyContent p {
  margin: 0 0 1em;
}

/* Headings */
.privacyContent h2 {
  font-size: 1.25rem;
  font-weight: 700;
  margin: 2em 0 0.6em;
  color: var(--color-text-primary);
  line-height: 1.3;
  padding-bottom: 6px;
  border-bottom: 1px solid var(--color-border);
}

.privacyContent h3 {
  font-size: 1rem;
  font-weight: 700;
  margin: 1.5em 0 0.5em;
  color: var(--color-text-primary);
}

/* Horizontal rules rendered from --- */
.privacyContent hr {
  border: none;
  border-top: 1px solid var(--color-border);
  margin: 2em 0;
}

/* Links */
.privacyContent a {
  color: var(--color-accent);
  text-decoration: underline;
  text-underline-offset: 2px;
}

.privacyContent a:hover {
  color: var(--color-accent-hover);
}

/* Strong / bold — slightly stronger colour for emphasis */
.privacyContent strong {
  font-weight: 700;
  color: var(--color-text-primary);
}

/* Lists */
.privacyContent ul,
.privacyContent ol {
  margin: 0 0 1em 1.5em;
  padding: 0;
}

.privacyContent li {
  margin-bottom: 0.4em;
}

/* Code (inline, e.g. `eu-north-1`) */
.privacyContent code {
  font-family: 'SFMono-Regular', Consolas, 'Liberation Mono', Menlo, monospace;
  font-size: 0.85em;
  background-color: var(--color-bg-secondary);
  color: var(--color-text-primary);
  padding: 0.1em 0.35em;
  border-radius: 3px;
}

/* ─── Tables ─────────────────────────────────────────────────────────────── */

.privacyContent table {
  width: 100%;
  border-collapse: collapse;
  margin: 0 0 1.5em;
  font-size: 0.875rem;
  /* Allow horizontal scroll on very narrow screens */
  display: block;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
}

.privacyContent thead {
  background-color: var(--color-bg-secondary);
}

.privacyContent th {
  text-align: left;
  font-weight: 700;
  color: var(--color-text-primary);
  padding: 10px 14px;
  border: 1px solid var(--color-border);
  white-space: nowrap;
}

.privacyContent td {
  padding: 9px 14px;
  border: 1px solid var(--color-border);
  color: var(--color-text-secondary);
  vertical-align: top;
}

/* Zebra striping */
.privacyContent tbody tr:nth-child(even) {
  background-color: var(--color-bg-secondary);
}

.privacyContent tbody tr:hover {
  background-color: var(--color-accent-subtle);
}
